import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import type { IButtonProps } from '@/DesignSystem/Model/DataModel';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { lessonSectionSetActiveTabNumber } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import { useAppDispatch } from '@/Module/Store/Hook';
interface ILessonBlurProps {
  onClick?: IButtonProps['onClick'];
  type?: string;
}
const LessonBlur: FC<ILessonBlurProps> = ({
  onClick,
  type
}) => {
  const deviceType = useDeviceType();
  const router = useRouter();
  const redirectLink = `${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`;
  const dispatch = useAppDispatch();
  const clickHandler = () => {
    dispatch(lessonSectionSetActiveTabNumber(1));
  };
  const icon = deviceType === DeviceType.MOBILE ? <Image width={80} height={75} src={`${FILE_BROWSER_URL}/img/icon-video.webp`} alt="icon-video" /> : <Image width={167} height={163} src={`${FILE_BROWSER_URL}/img/icon-video.webp`} alt="icon-video" />;
  return <div className={`flex w-full flex-col items-center justify-center  ${type === 'handout' ? 'h fixed inset-0 z-[100]    bg-[#474A57F8]' : 'absolute left-0 top-0 z-10  h-full   bg-[#474A57E1]'}`} data-sentry-component="LessonBlur" data-sentry-source-file="LessonBlur.tsx">
      <div className="md:max-w-[90px] lg:max-w-full">{icon}</div>
      {type === 'handout' ? <p className="lg:leading-10 mb-3 max-w-[296px] text-center text-sm font-black leading-middle text-[#FFBD12] lg:mb-7 lg:max-w-[505px] lg:text-2xl ">
          ثبت‌نام کن و ( 3 روز اشتراک رایگان) بگیر
          <br />
          برای دسترسی به همه ویدیوها کافیه ثبت‌نام کنی{' '}
        </p> : <p className="lg:leading-10 mb-2 max-w-[320px] text-center text-sm font-black leading-middle text-[#FFBD12] lg:mb-7 lg:mt-4 lg:max-w-[505px] lg:text-2xl ">
          ثبت‌نام کن و ( 3 روز اشتراک رایگان) بگیر
          <br />
          برای دسترسی به همه ویدیوها کافیه ثبت‌نام کنی{' '}
        </p>}

      <Button as={Link} href={redirectLink} onClick={onClick} variant="shadow" color="primary" radius="circle" size="large" className="h-[30px] w-[266px] text-sm font-black lg:h-[56px] lg:w-[254px]" data-sentry-element="Button" data-sentry-source-file="LessonBlur.tsx">
        ورود و ثبت نام
      </Button>
      {type === 'handout' ? <Button as="a" onClick={clickHandler} variant="shadow" color="orangeMiddle" radius="circle" size="small" className=" mt-4 cursor-pointer text-sm font-black">
          بعدا
        </Button> : ''}
    </div>;
};
export default LessonBlur;